// extracted by mini-css-extract-plugin
module.exports = {"shopNowCell":"az_G4c","shopNowButton":"az_H4c","comparisonFitmentButton":"az_I4c"};